import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

$(function () {

  $('.popup-player').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade01',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    iframe: {
      markup: '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
        '</div>',

      srcAction: 'iframe_src',
    }
  });
});

$(document).ready(function () {
  $('.modal-trigger').magnificPopup({
    type: 'inline',
    preloader: false,
    modal: true,
    items: {
      src: '.modal-content'
    },
    removalDelay: 300, // アニメーション時間
    mainClass: 'mfp-fade', // フェードエフェクトを追加
    callbacks: {
      beforeOpen: function () {
        // アニメーション用のクラスを追加
        this.st.mainClass = 'mfp-fade';
      }
    }
  });

  // 閉じるボタンの処理
  $(document).on('click', '.modal-close', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
});
